import 'babel-polyfill';
import Vue from 'vue';
import Fragment from 'vue-fragment';
import { CollapsePlugin } from 'bootstrap-vue';  // ui plugins
import store from './store';
import App from './containers/search-list-filter-app.vue';

Vue.use(Fragment.Plugin);
Vue.use(CollapsePlugin);

// init app
new Vue({
	store,
	components: {
		app: App
	},
}).$mount('#search-list-filter-app');